import { css } from '@emotion/css'
import { spacing, colors, mediaQueryHelper, breakpoint } from '@offerzen/pinata'

const styles = {
  preview: css({
    width: '100%',

    '> section, > aside': {
      paddingLeft: spacing.default,
      paddingRight: spacing.default,
      marginBottom: spacing.large,

      [mediaQueryHelper(breakpoint.tablet)]: {
        paddingLeft: spacing.large,
        paddingRight: spacing.large,
        marginBottom: spacing.extraLarge,
      },

      [mediaQueryHelper(breakpoint.desktop)]: {
        paddingLeft: spacing.extraLarge,
        paddingRight: spacing.extraLarge,
      },
    },

    '> section:first-of-type': {
      paddingTop: spacing.large,
      paddingBottom: spacing.large,
      borderBottom: `1px solid ${colors.mystic}`,

      [mediaQueryHelper(breakpoint.tablet)]: {
        paddingTop: spacing.extraLarge,
        paddingBottom: spacing.extraLarge,
      },
    },
  }),
}

export default styles
